export const parseRoles = value => {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value !== "string" || !value.trim()) return [];
  return value.replaceAll(" ", "").replace(/\[|\]/g, "").split(",").filter(Boolean);
};

export const parsePermissions = value => {
  if (Array.isArray(value)) {
    return value.map(item => typeof item === "string" ? item : item?.code).filter(Boolean);
  }
  if (typeof value !== "string" || !value.trim()) return [];
  return value.replaceAll(" ", "").replace(/\[|\]/g, "").split(",").filter(Boolean);
};

export const buildAuthSession = (data, previous = {}) => ({
  ...previous,
  user: data?.username ?? null,
  accessToken: data?.accessToken ?? null,
  id: data?.id ?? null,
  employeeId: data?.employeeId ?? null,
  linkedEmployee: data?.linkedEmployee === true || data?.linkedEmployee === "true" || data?.employeeId != null,
  roles: parseRoles(data?.roles),
  permissions: parsePermissions(data?.permissions),
  displayName: data?.displayName || data?.username || null,
  impersonated: data?.impersonated === true || data?.impersonated === "true",
  impersonatorUser: data?.impersonatorUsername || null,
  impersonatorId: data?.impersonatorId || null,
  impersonatorDisplayName: data?.impersonatorDisplayName || data?.impersonatorUsername || null
});

